// extracted by mini-css-extract-plugin
export default {"container":"z0nZrkcIkj","mobile-dropdown":"_358rmeLQ3U","mobileDropdown":"_358rmeLQ3U","mobileDropdownItem":"U2lnAhwAQS","user-header":"_3TJcOa4V7l","userHeader":"_3TJcOa4V7l","user-icon":"_3sxlCjxuoh","userIcon":"_3sxlCjxuoh","user-message":"uBJmt2iP0A","userMessage":"uBJmt2iP0A","profile-picture-mobile":"_3Wzu52K7JB","profilePictureMobile":"_3Wzu52K7JB"};
    if(module.hot) {
      // 1622798377598
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  